import type { TransferRepository } from '@/core/transfer'
import type { UseCase } from '@/core/shared'

export const getTransfer: UseCase<TransferRepository, 'getTransfer'> = repository => {
  return async (token) => {
    return await repository.getTransfer(token)
  }
}
